import React, {forwardRef, useEffect, useImperativeHandle, useRef, useState} from "react";
import Map from "./Map";
import {useUserContext} from "../../../context/UserContext";
import './Gls.scss';
import {T} from '../../../utils/I18n/I18n';
import CheckoutEmailOrLogin from "../CheckoutEmailOrLogin";
import useCartMutation from "../../../hooks/useCartMutation";
import {SET_SHIPPING_ADDRESS, SET_SHIPPING_METHOD} from "../../../queries/cart";
import {useCartContext} from "../../../context/CartContext";
import useSetGuestEmailOnCart from "../../../hooks/useSetGuestEmail";
import Prices from "../../../components/BaseCurrencyPrices/Prices";


const GlsForm = forwardRef(({setIsDisabled, method}, ref) => {
    const {user} = useUserContext();
    const {cart} = useCartContext();
    const setGuestEmail = useSetGuestEmailOnCart();
    const formRef = useRef();
    const [selectedPoint, setSelectedPoint] = useState(JSON.parse(localStorage.getItem('selectedPoint')))
    const [openMap, setOpenMap] = useState(false)
    const [setShippimgAddressMutation] = useCartMutation(SET_SHIPPING_ADDRESS);
    const [setShippimgMethodMutation] = useCartMutation(SET_SHIPPING_METHOD);
    const [email, setEmail] = useState(cart.email);
    const [error, setError] = useState(null)



    useImperativeHandle(
        ref,
        () => ({
            submit: async () => {
                try {
                    if (!selectedPoint) {
                        setError('Select point');
                        return Promise.reject(error);
                    }
                    if (!formRef.current.reportValidity()) {
                        return Promise.reject();
                    }
                    if (!user) {
                        await setGuestEmail(email);
                    }

                    await setShippimgAddressMutation({
                        variables: {
                            input: {
                                shipping_addresses: [
                                    {
                                        address: Object.assign({}, selectedPoint, {save_in_address_book: false})
                                    }
                                ]
                            }
                        }
                        }
                    )
                    await setShippimgMethodMutation(
                        {
                            variables: {
                                input: {
                                    shipping_methods: [
                                        {carrier_code: 'glsparcelshop', method_code: 'glsparcelshop'}
                                    ]
                                }
                            }
                        }
                    )

                    return Promise.resolve();
                } catch (error) {
                    console.error('Error during submit:', error);
                    return Promise.reject(error);
                }
            },
        }),
        [user, cart, selectedPoint, email],
    );

    useEffect(() => {
        if (selectedPoint) {
            setIsDisabled(false)
        }
    }, [selectedPoint])
    const setPoint = (point) => {
        const addressPoint = {
            city: point.contact.city,
            postcode: point.contact.postalCode,
            country_code: point.contact.countryCode,
            firstname: point.id,
            lastname: point.name,
            street: [point.contact.address],
            telephone: '111111111',
        }
        localStorage.setItem('selectedPoint', JSON.stringify(addressPoint));
        setSelectedPoint(addressPoint)
        setOpenMap(false)
        formRef.current.reportValidity()
    }
    return (
        <>
            <form ref={formRef}>
                {!user && <CheckoutEmailOrLogin email={email} setEmail={setEmail}/>}
                <div className='parcelshop-form'>

                    <div className='ico' onClick={() => setOpenMap(!openMap)}></div>
                    {!selectedPoint &&
                        <div className={error ? 'error' : null} onClick={() => setOpenMap(!openMap)}><T
                            id="cartSummary.selectPickupPoint"/></div>
                    }

                    {selectedPoint && <div onClick={() => setOpenMap(!openMap)}>
                        <div>{selectedPoint.firstname}</div>
                        <div>{selectedPoint.lastname}</div>
                        <div>{selectedPoint.street}</div>
                        <div>{selectedPoint.postcode} {selectedPoint.city}</div>
                    </div>
                    }
                </div>
            </form>
            <div className="checkout__main__form__shipping">
                <div className="shipping-method-radio">
                    <div className='shipping-method-radio__label'>
                        <T id="product.deliveryTab"/>
                    </div>
                    <div className='shipping-method-radio__price'>
                        <Prices amount={method.amount}/>
                    </div>
                </div>
            </div>
            {openMap == true && <Map setPoint={setPoint}/>}
        </>
    )
});

export default GlsForm;